interface StatusIndicatorProps {
  status: "active" | "inactive" | "warning" | "error" | "success" | "neutral";
  size?: "sm" | "md" | "lg";
}

export default function StatusIndicator({
  status,
  size = "md",
}: StatusIndicatorProps) {
  const sizeClasses = {
    sm: "w-2 h-2",
    md: "w-3 h-3",
    lg: "w-4 h-4",
  };

  const statusClasses = {
    active: "bg-blue-500",
    inactive: "bg-gray-300",
    neutral: "bg-gray-400",
    warning: "bg-red-300",
    error: "bg-red-500",
    success: "bg-green-500",
  };

  return (
    <div
      className={`${sizeClasses[size]} ${statusClasses[status]} rounded-full inline-block`}
    />
  );
}
